import { useId } from 'react';
import { usePM2DisplayContext } from '@pm2/store';
import { Link } from '@provider/navigation';
import { resets } from '@ui/css';
import { PostloadedImage } from '@utils/react';
import { SlideCaption } from './atom.slide-caption.js';
import { imageCls, root, imageWrapper, imageButton, linkSurface, link } from './atom.slide.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function Slide(props) {
  const {
    inLightbox
  } = usePM2DisplayContext();
  const id = useId();
  const image = /*#__PURE__*/jsx(PostloadedImage, {
    className: imageCls,
    src: props.model.image.src,
    width: props.model.image.width,
    height: props.model.image.height,
    alt: props.model.image.alt ?? "",
    loading: props.isVisible ? "eager" : "lazy",
    sizes: `min(100vw, ${Math.round(1110 / props.desiredCarouselCount)}px)`
  });
  return /*#__PURE__*/jsxs("div", {
    className: root,
    tabIndex: props.model.link ? undefined : -1,
    children: [/*#__PURE__*/jsxs("div", {
      className: imageWrapper,
      children: [inLightbox ? image : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("button", {
          className: imageButton,
          "aria-describedby": id,
          onClick: props.handleOpenSlideInLightbox,
          children: image
        }), /*#__PURE__*/jsx("div", {
          id: id,
          className: resets.screenReaderOnlyCls,
          children: "\xC5bn billede i lightbox"
        })]
      }), /*#__PURE__*/jsx(SlideLink, {
        link: props.model.link
      })]
    }), /*#__PURE__*/jsx(SlideCaption, {
      caption: props.model.caption,
      inLightbox: inLightbox
    })]
  });
}
function SlideLink(props) {
  if (!props.link) {
    return null;
  }
  return /*#__PURE__*/jsx(Link, {
    href: props.link.href,
    target: props.link.target,
    className: link,
    style: linkSurface.__override({
      color: props.link.color,
      background: props.link.background
    }),
    tabIndex: -1,
    children: props.link.label
  });
}

export { Slide };
//# sourceMappingURL=atom.slide.js.map
